import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { WhitelabelEnum } from '@model/enum/whitelabel.enum';
import { ConfigService } from '@services/webFeeder/config.service';

@Injectable({
  providedIn: 'root'
})
export class CedroViewGuard  {

  constructor(
    private router: Router,
    private config: ConfigService
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const whiteLabel = this.config.getWhiteLabel();
    if (whiteLabel === WhitelabelEnum.CEDRO) {
      return true;
    } else {
      this.router.navigate(['/error'], { queryParams: { type: 'unauthorized' } });
    }
  }
}
